import 'assets/images/rover-wheel.svg';
import './splash-screen.sass';

import React, { Component } from 'react';

export default function SplashScreen() {
  return (
    <div className='splash-screen'>
      <div className='splash-screen__img'></div>
    </div>
  );
}
